import { EntryType } from '@fx-ui/jdy-design-biz';

/**
 * 获取EntryIcon所需要的IconType
 *
 * @param entry 表单数据
 * @param entry.type 表单类型
 * @param entry.hasCoop 流程表单标识
 */
export const getEntryIconByEntry = (entry: { type: string; hasCoop?: boolean }) => {
    if (entry.type === 'form' && !entry.hasCoop) {
        return 'flow';
    }

    if (entry.type === 'automation') {
        return 'trigger';
    }

    return entry.type as EntryType;
};
